module.exports = __webpack_public_path__ + "static/petersen-29e2f2b058e9821f6f64812ce88e2b07.png";